import { Icon } from '@argon';

export default Icon;
